import React from 'react';

export default function AdminAgencyList({
    t,
    i18n,
    filteredAgencies,
    cities,
    handleEditAgencyClick,
    handleDeleteAgency,
    handleResetPassword,
    cityFilter,
    setCityFilter,
    nameSearch,
    setNameSearch
}) {
    return (
        <div className="space-y-6">
            {/* Filters */}
            <div className="bg-bg-card border border-gold/20 shadow-lg rounded-lg p-4">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
                        <label className="block text-sm font-medium text-text-muted mb-1">{t('filterByCity')}</label>
                        <select
                            className="bg-bg-soft border border-gold/20 text-text rounded px-3 py-2 w-full focus:ring-gold focus:border-gold"
                            value={cityFilter} onChange={e => setCityFilter(e.target.value)}
                        >
                            <option value="">{t('allCities')}</option>
                            {(cities || []).map(city => <option key={city.en} value={city.en}>{i18n.language === 'ar' ? city.ar : city.en}</option>)}
                        </select>
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-text-muted mb-1">{t('searchByName')}</label>
                        <input
                            type="text"
                            className="bg-bg-soft border border-gold/20 text-text rounded px-3 py-2 w-full focus:ring-gold focus:border-gold"
                            placeholder={t('searchByName')}
                            value={nameSearch} onChange={e => setNameSearch(e.target.value)}
                        />
                    </div>
                </div>
            </div>

            {/* Agencies List - Desktop Table */}
            <div className="hidden sm:block bg-bg-card border border-gold/20 shadow-lg rounded-lg overflow-hidden">
                <table className="min-w-full divide-y divide-gold/10">
                    <thead className="bg-gray-50">
                        <tr>
                            <th className="px-6 py-3 text-left text-xs font-medium text-text-muted uppercase tracking-wider">{t('logo')}</th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-text-muted uppercase tracking-wider">{t('name')}</th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-text-muted uppercase tracking-wider">{t('clientEmail')}</th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-text-muted uppercase tracking-wider">{t('city')}</th>
                            <th className="px-6 py-3 text-right text-xs font-medium text-text-muted uppercase tracking-wider">{t('actions')}</th>
                        </tr>
                    </thead>
                    <tbody className="bg-bg-card divide-y divide-gold/5">
                        {(filteredAgencies || []).map(agency => (
                            <tr key={agency.id}>
                                <td className="px-6 py-4 whitespace-nowrap">
                                    {agency.logo ? (
                                        <img src={`${import.meta.env.VITE_API_URL || ''}/static/agency_logos/${agency.logo}`} alt={i18n.language === 'ar' ? (agency.name_ar || agency.name) : (agency.name_en || agency.name)} className="h-10 w-10 object-contain" />
                                    ) : (
                                        <span className="text-text-muted">-</span>
                                    )}
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap text-text">{i18n.language === 'ar' ? (agency.name_ar || agency.name) : (agency.name_en || agency.name)}</td>
                                <td className="px-6 py-4 whitespace-nowrap text-text-muted">{agency.client_email}</td>
                                <td className="px-6 py-4 whitespace-nowrap text-text-muted">
                                    {agency.city ? (i18n.language === 'ar' ? cities.find(c => c.en === agency.city)?.ar : agency.city) : '-'}
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium space-x-2">
                                    <button
                                        onClick={() => handleEditAgencyClick(agency)}
                                        className="p-2 text-gold hover:bg-gold/10 rounded-full transition-colors duration-200 min-h-[44px] min-w-[44px] inline-flex items-center justify-center border border-gold/20"
                                        title={t('edit')}
                                    >
                                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
                                        </svg>
                                    </button>
                                    <a
                                        href={`/agency/${agency.slug}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="p-2 text-text-muted hover:text-white hover:bg-white/10 rounded-full transition-colors duration-200 min-h-[44px] min-w-[44px] inline-flex items-center justify-center border border-white/10"
                                        title="View Public Page"
                                    >
                                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                                        </svg>
                                    </a>
                                    <button
                                        onClick={() => handleResetPassword(agency.id)}
                                        className="p-2 text-text-muted hover:text-gold hover:bg-gold/10 rounded-full transition-colors duration-200 min-h-[44px] min-w-[44px] inline-flex items-center justify-center border border-gold/20"
                                        title={t('resetPassword')}
                                    >
                                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 7a2 2 0 012 2m4 0a6 6 0 01-7.743 5.743L11 17H9v2H7v2H4a1 1 0 01-1-1v-2.586a1 1 0 01.293-.707l5.964-5.964A6 6 0 1121 9z" />
                                        </svg>
                                    </button>
                                    <button
                                        onClick={() => handleDeleteAgency(agency.id)}
                                        className="p-2 text-danger-400 hover:bg-danger-900/30 rounded-full transition-colors duration-200 min-h-[44px] min-w-[44px] inline-flex items-center justify-center border border-danger-500/30"
                                        title={t('delete')}
                                    >
                                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                                        </svg>
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            {/* Agencies List - Mobile Cards */}
            <div className="sm:hidden space-y-4">
                {(filteredAgencies || []).map(agency => (
                    <div key={agency.id} className="bg-bg-card border border-gold/20 shadow-lg rounded-lg p-4 space-y-4">
                        <div className="flex items-center space-x-4">
                            {agency.logo ? (
                                <img src={`${import.meta.env.VITE_API_URL || ''}/static/agency_logos/${agency.logo}`} alt={i18n.language === 'ar' ? (agency.name_ar || agency.name) : (agency.name_en || agency.name)} className="h-16 w-16 object-contain" />
                            ) : (
                                <div className="h-16 w-16 rounded bg-gray-50 border border-gold/10 flex items-center justify-center text-text-muted">
                                    <span className="text-2xl">-</span>
                                </div>
                            )}
                            <div className="flex-1 min-w-0">
                                <h4 className="text-lg font-bold text-text truncate">{i18n.language === 'ar' ? (agency.name_ar || agency.name) : (agency.name_en || agency.name)}</h4>
                                <p className="text-sm text-text-muted truncate">{agency.client_email}</p>
                                <p className="text-sm text-text-muted truncate">
                                    {agency.city ? (i18n.language === 'ar' ? cities.find(c => c.en === agency.city)?.ar : agency.city) : '-'}
                                </p>
                            </div>
                        </div>

                        <div className="flex justify-between items-center pt-4 border-t border-gold/10">
                            <div className="flex gap-2">
                                <button
                                    onClick={() => handleEditAgencyClick(agency)}
                                    className="p-2 text-gold bg-bg-card border border-gold/20 hover:bg-gold/10 rounded-lg transition-colors duration-200 min-h-[44px] min-w-[44px] flex items-center justify-center"
                                    title={t('edit')}
                                >
                                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
                                    </svg>
                                </button>
                                <a
                                    href={`/agency/${agency.slug}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="p-2 text-text-muted bg-bg-card border border-white/10 hover:bg-white/10 hover:text-white rounded-lg transition-colors duration-200 min-h-[44px] min-w-[44px] flex items-center justify-center"
                                    title="View Public Page"
                                >
                                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                                    </svg>
                                </a>
                                <button
                                    onClick={() => handleResetPassword(agency.id)}
                                    className="p-2 text-text-muted bg-bg-card border border-gold/20 hover:text-gold hover:bg-gold/10 rounded-lg transition-colors duration-200 min-h-[44px] min-w-[44px] flex items-center justify-center"
                                    title={t('resetPassword')}
                                >
                                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 7a2 2 0 012 2m4 0a6 6 0 01-7.743 5.743L11 17H9v2H7v2H4a1 1 0 01-1-1v-2.586a1 1 0 01.293-.707l5.964-5.964A6 6 0 1121 9z" />
                                    </svg>
                                </button>
                            </div>
                            <button
                                onClick={() => handleDeleteAgency(agency.id)}
                                className="p-2 text-danger-400 bg-bg-card border border-danger-500/30 hover:bg-danger-900/30 rounded-lg transition-colors duration-200 min-h-[44px] min-w-[44px] flex items-center justify-center"
                                title={t('delete')}
                            >
                                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                                </svg>
                            </button>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}
